const SubscribeForm = (target) => {
  const $body = $('body')
  const $target = $body.find(target)
  if ($target.length) {
    const $form  = $target.find('form')
    $form.on('submit', () => {
      window.dataLayer.push({
        event: 'contact_form',
        newsletter_subscribed_form: 'Contact form',
        template_name: 'contact',
      })
    })
  }
  if($body.hasClass('page-template-template-validation-nl')) {
    window.dataLayer.push({
      event: 'newsletter_subscribed',
      newsletter_subscribed_form: 'Newsletter form',
      template_name: 'contact',
    })
  }
}

export default SubscribeForm



// WEBPACK FOOTER //
// ./scripts/components/SubscribeForm.js